import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

import useI18n from 'src/hooks/i18n'
import { GetterTypes } from 'src/types/stores/auth'
import { MenuItem } from '../../types/menu'
import { RouteLocationNormalizedArgumented } from 'src/types/route'
import { computed } from 'vue'
import { useAuthStore } from 'src/stores/modules/auth'
import { useCarBodyPendingCountStore } from 'src/stores/modules/carbody/pending-count'
import { useRouter } from 'vue-router'

interface Props {
  item: MenuItem
  inset?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerItem',
  props: {
    item: {},
    inset: { default: 0 }
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n()
const store = useAuthStore()
const router = useRouter()
const carBodyPendingCountStore = useCarBodyPendingCountStore()

// Resolves `item.badge` (a closed union of known sources) to a live count —
// currently only the CarBody pending-products navbar badge (item 6).
const badgeCount = computed(() => {
  if (props.item.badge === 'carBodyPendingCount') {
    return carBodyPendingCountStore.count
  }
  return 0
})

const isVisible = computed(() => {
  return (
    !props.item.permission || store[GetterTypes.USER_CAN](props.item.permission)
  )
})

const insetLevel = computed(() => props.inset * 0.22)

const route = computed(() => {
  if (props.item.old || props.item.link) return undefined
  if (props.item.to) return props.item.to
  if (!props.item.route) return undefined

  return { name: props.item.route }
})

const open = computed(() => {
  if (props.item.open) return true

  const identifier = props.item.route ?? props.item.id

  if (identifier === undefined) return false

  const itemRoute = router.getRoutes().find((route) => route.name == identifier)

  const matched = router.currentRoute.value
    .matched as unknown as RouteLocationNormalizedArgumented[]

  return matched.some(
    (record: RouteLocationNormalizedArgumented) =>
      record.path == itemRoute?.path ||
      record.meta.belongsTo?.includes(itemRoute?.name ?? identifier)
  )
})

const classes = computed(() => {
  const classes = [props.item.class]

  if (open.value) {
    classes.push('q-router-link--active')
  }
  return classes
})

function routeIfRequested(): void {
  if (!!props.item.link) {
    window.open(props.item.link, '_blank')
    return
  }

  const routeValue = !!props.item.old
    ? `${String(process.env.OLD_URI)}${props.item.old}`
    : route

  const routeString = String(routeValue)
  if (/^http.*/.test(routeString)) document.location.href = routeString
}

return (_ctx: any,_cache: any) => {
  const _component_DrawerItem = _resolveComponent("DrawerItem", true)!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_item = _resolveComponent("q-item")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (isVisible.value)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (props.item.menu === true)
          ? (_openBlock(), _createBlock(_component_q_expansion_item, {
              key: 0,
              "header-inset-level": insetLevel.value,
              to: route.value,
              label: _unref(t)(`sidebar.${props.item.label}`),
              icon: props.item.icon,
              "header-class": classes.value,
              "model-value": open.value
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.items, (subItem, index) => {
                  return (_openBlock(), _createBlock(_component_DrawerItem, {
                    inset: props.inset + 1,
                    item: subItem,
                    key: `menu_${subItem.label}_${index}`
                  }, null, 8, ["inset", "item"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["header-inset-level", "to", "label", "icon", "header-class", "model-value"]))
          : _withDirectives((_openBlock(), _createBlock(_component_q_item, {
              key: 1,
              clickable: "",
              class: _normalizeClass(props.item.class),
              "inset-level": insetLevel.value,
              to: route.value,
              onClick: routeIfRequested
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { avatar: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: props.item.icon
                    }, null, 8, ["name"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_item_section, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)(`sidebar.${props.item.label}`)), 1)
                  ]),
                  _: 1
                }),
                (props.item.badge && badgeCount.value > 0)
                  ? (_openBlock(), _createBlock(_component_q_item_section, {
                      key: 0,
                      side: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_badge, {
                          color: "red",
                          rounded: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(badgeCount.value), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class", "inset-level", "to"])), [
              [_directive_ripple]
            ])
      ], 64))
    : _createCommentVNode("", true)
}
}

})